import api from '@/api/sisImportTemplates/components'
import baseModule from '@/store/shared/graphql'

const STORE_TYPE = 'SIS_IMPORT_TEMPLATE_COMPONENTS'
const API_DATA_KEY = 'component'
const API_DATA_BY_ID_KEY = 'component_name'
const defaultModule = baseModule(STORE_TYPE, API_DATA_BY_ID_KEY, API_DATA_KEY, api)

export default { ...defaultModule, namespaced: true }
